import { TranslocoGlobalConfig } from '@jsverse/transloco-utils';

export const DEFAULT_LOCALE_CODE: LocaleCode = 'fr';
export const TRANSLOCO_LANG_STORAGE_KEY = 'translocoLang';

export type LocaleCode = 'en' | 'en-GB' | 'en-US' | 'fr' | 'es' | 'de';

const config: TranslocoGlobalConfig = {
  rootTranslationsPath: 'src/assets/i18n/',
  langs: ['fr', 'en-GB', 'en-US', 'es', 'de'],
  keysManager: {},
};

export default config;
